export default "__VITE_ASSET__BmSXRouq__"